import React from 'react'
import styles from './ProgressCards.module.css'



export default function ProgressCard({title,values,children}) {
    return (
        <div className={styles.size}>
            <div className={styles.top_text}>
                <h3>{title}</h3>
                <p>{values}</p>
            </div>
            <div className={styles.body}>
               
                {children}
                
            </div>
        </div>
    )
}
